<template>
  <div class="slider-container">
    <div v-for="(slide, index) in slidesData" :key="index"
      :class="['slide', { 'active': currentSlideIndex === index }]">
      <transition name="fade">
        <div class="slide-content-wrapper" v-if="currentSlideIndex === index">

          <div class="content-text">
            <h1>{{ slide.title }}</h1>

            <div class='line'></div>
            <div class="box">
              <span class="light">{{ slide.subtitle }}</span>
            </div>

            <div class="dots-container">
              <span v-for="(s, i) in slidesData" :key="'dot-' + i"
                :class="['dot', { 'active': currentSlideIndex === i }]" @click="goToSlide(i)"></span>
            </div>
          </div>

          <div class="content-image">
            <img :src="slide.imageUrl" :alt="slide.title">
          </div>

        </div>
      </transition>
    </div>

  </div>
</template>

<script>
import translationStore from '@/store/translations'

export default {
  name: 'SliderCarosello',
  data () {
    return {
      currentSlideIndex: 0,

      slidesStaticData: [
        {
          titleKey: 'Igotu.40',
          subtitleKey: 'no.more.list.paper',
          // Rimosso buttonKey e buttonText non essendo presenti nel tuo ultimo esempio
          imageUrl: require('@/assets/img/carosel/slide1.png')
        },
        {
          // 💡 AGGIUNTO titleKey per la reattività
          titleKey: 'create.your.guest.list',
          // 💡 AGGIUNTO subtitleKey per la reattività
          subtitleKey: '',
          imageUrl: require('@/assets/img/carosel/slide2.png')
        },
        {
          titleKey: 'Igotu.44',
          subtitleKey: '',
          imageUrl: require('@/assets/img/carosel/slide3.png')
        },
        {
          titleKey: 'Igotu.120',
          subtitleKey: '',
          imageUrl: require('@/assets/img/carosel/slide4.png')
        }
      ],
      intervalId: null,
      intervalTime: 5000 // 5 secondi
    }
  },

  computed: {
    // Getter della funzione di traduzione dallo Store (dipendenza reattiva)
    translation () {
      return translationStore.getters.traduzione
    },

    // Proprietà che genera l'array di slide TRADOTTO e REATTIVO
    slidesData () {
      return this.slidesStaticData.map(slide => {
        // 1. Traduzione del Titolo: usa titleKey se presente, altrimenti il valore di title
        const translatedTitle = slide.titleKey
          ? this.translation(slide.titleKey)
          : slide.title

        // 2. Traduzione del Sottotitolo: usa subtitleKey se presente, altrimenti il valore di subtitle
        const translatedSubtitle = slide.subtitleKey
          ? this.translation(slide.subtitleKey)
          : slide.subtitle

        // 3. Traduzione del Bottone (se presente)
        const translatedButtonText = slide.buttonKey
          ? this.translation(slide.buttonKey)
          : slide.buttonText

        return {
          ...slide,
          title: translatedTitle,
          subtitle: translatedSubtitle,
          buttonText: translatedButtonText,
          imageUrl: slide.imageUrl
        }
      })
    }
  },

  mounted () {
    this.startAutoPlay()
  },

  beforeDestroy () {
    clearInterval(this.intervalId)
  },

  methods: {
    goToSlide (newIndex) {
      this.currentSlideIndex = newIndex
      this.resetAutoPlay()
    },
    nextSlide () {
      const nextIndex = (this.currentSlideIndex + 1) % this.slidesData.length
      this.goToSlide(nextIndex)
    },
    prevSlide () {
      const prevIndex = (this.currentSlideIndex - 1 + this.slidesData.length) % this.slidesData.length
      this.goToSlide(prevIndex)
    },
    startAutoPlay () {
      this.intervalId = setInterval(this.nextSlide, this.intervalTime)
    },
    resetAutoPlay () {
      clearInterval(this.intervalId)
      this.startAutoPlay()
    }
  }
}
</script>

---

<style scoped>
/* ---------------------------------------------------- */
/* Contenitore Generale e Transizione */
/* ---------------------------------------------------- */
.slider-container {
  position: relative;
  width: 95%;
  border-radius: 0px;
  overflow: hidden;
  margin: 0px auto;
  min-height: 450px;
  background-color: #272727;
}

.slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.8s ease-in-out;
}

.slide.active {
  opacity: 1;
  z-index: 1;
}

/* Transizione del Contenuto */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* ---------------------------------------------------- */
/* Layout a Due Colonne (Flexbox) */
/* ---------------------------------------------------- */

.slide-content-wrapper {
  display: flex;
  height: 100%;
  width: 100%;
}

.content-text {
  flex: 0 0 55%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 60px 40px;
  background-color: #272727;
  color: white;
  text-align: left;
}

.content-text h1 {
  font-size: 2.2em;
  margin-bottom: 10px;
  font-weight: 700;
  color: white;
}

.content-text p {
  font-size: 1.1em;
  margin-bottom: 25px;
  color: #FFF;
}

.content-image {
  flex: 0 0 45%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #272727;
}

.content-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* ---------------------------------------------------- */
/* Stili Controlli (Dots) */
/* ---------------------------------------------------- */
.dots-container {
  position: relative;
  margin-top: 30px;
  left: 0;
  transform: none;
  z-index: 10;
  display: flex;
  gap: 8px;
  padding: 5px 0px;
  background: transparent !important;
  border-radius: 0;
}

.dot {
  height: 10px;
  width: 10px;
  background-color: #bbb;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
}

.dot.active {
  background-color: #1a73e8;
  transform: scale(1.2);
}

.light {
  font-weight: 300 !important;
}

/* ---------------------------------------------------- */
/* Media Query (Layout verticale su schermi piccoli) */
/* ---------------------------------------------------- */

@media (max-width: 768px) {
  .slide-content-wrapper {
    flex-direction: column;
  }

  .content-text,
  .content-image {
    flex: none;
    width: 100%;
  }

  .content-text {
    padding: 30px 20px;
    text-align: center;
    align-items: center;
  }

  .content-image {
    height: 200px;
  }

  /* Centra i dots su mobile */
  .dots-container {
    left: 50%;
    transform: translateX(-50%);
    margin-top: 20px;
  }
}
</style>
